export default {
  tabs: {
    gift_cards: 'Carduri cadou',
    settings: 'Setări',
  },
  gift_cards: {
    title: 'Carduri cadou',
    subtitle: 'Gestionați toate cardurile cadou ale restaurantului dvs.',
    buttons: {
      create: 'Creați card cadou',
      redeem: 'Utilizați card cadou',
      check_balance: 'Verificați soldul',
    },
    search: {
      placeholder: 'Introduceți text de căutare',
    },
    columns: {
      code: 'Cod',
      status: 'Stare',
      balance: 'Sold',
      value: 'Valoare',
      email: 'Cumpărător',
      source: 'Sursă',
      created_at: 'Creat',
    },
    statuses: {
      active: 'Activ',
      partially_redeemed: 'Utilizat parțial',
      redeemed: 'Utilizat',
    },
  },
  settings: {
    gift_cards_availability: {
      title: 'Setări carduri cadou',
      subtitle: 'Configurați opțiunile de card cadou pentru restaurantul dvs.',
      availability: {
        title: 'Activați cardurile cadou',
        subtitle: 'Permiteți clienților să cumpere și să utilizeze carduri cadou',
        buttons: {
          enable: 'Activare',
          disable: 'Dezactivare',
        },
      },
    },
    redemption_options: {
      title: 'Opțiuni de utilizare',
      subtitle: 'Alegeți unde pot fi utilizate cardurile cadou',
      redemption_mode: {
        title: 'Modul de utilizare',
        subtitle: 'Aceasta afectează textul afișat pe pagina de destinație a cardului cadou',
        buttons: {
          online: 'Doar online',
          online_and_store: 'Online și în magazin',
        },
      },
    },
  },
  summary: {
    total_value: 'Valoare totală',
    total_active: 'Total active',
    redeemed_this_month: 'Utilizate luna aceasta',
  },
};
